import React, { useEffect } from 'react';
import { Trans, useTranslation } from "react-i18next";
import { Alert } from 'reactstrap';
import classNames from "classnames";
import { collapsedSidebarState } from "../../../atoms";
import { useRecoilState } from "recoil";
import { useOrganisationContext } from 'hooks';

const LayoutUser = (props) => {
    const { t, i18n } = useTranslation();
    const dir = i18n.dir();
    
    const [collapsedSidebar] = useRecoilState(collapsedSidebarState);

    const { selectedOrganisation } = useOrganisationContext()
    const subscriptionRemainingDays = selectedOrganisation?.subscription_remaining_days || 0

    let subscriptionAlertMsg = null

    if (!selectedOrganisation?.has_upcoming_subscription) {
        if (subscriptionRemainingDays === 1) {
            subscriptionAlertMsg = t(`You will lose access to the system for selected organisation after ${subscriptionRemainingDays} day.`)
        } else if (subscriptionRemainingDays > 1 && subscriptionRemainingDays <= 30) {
            subscriptionAlertMsg = t(`Your subscription will end for selected organisation in ${subscriptionRemainingDays} days.`)
        }
    }

    useEffect(() => {
        document.body.dir = dir || "ltr";
    },[dir])

    return (
        // <div> LayoutHome {children}</div>
        <>
            <div
            id="main-wrapper"
            data-layout="vertical"
            data-sidebartype="full"
            data-sidebar-position="fixed"
            data-header-position="fixed"
            data-boxed-layout="full"
            dir={dir} className={dir}
            >   
                {/* <div className="loader-holder" id="loader-holder"> </div> */}
                {props.children}
                <div 
                    className={`
                        page-wrapper d-block ${dir== "rtl" ? "fix-rtl" : ""} ${dir== "rtl" && collapsedSidebar== true  ? "fix-rtl-collapse" : ""} `}
                    style={collapsedSidebar== true ? {marginLeft:"50px"} : {}}
                >
                    {subscriptionAlertMsg && (
                        <Alert color="warning" className="text-center text-sm py-1">
                            <strong>
                                {subscriptionAlertMsg}
                            </strong>
                        </Alert>
                    )}

                    <div className="page-content container-fluid">
                        {props.body}
                    </div>
                </div>
                <div dir={dir} className={classNames(dir, "d-print-none")}>
                    {/* {!user ? <Footer /> : <></>} */}
                    {/* {_showHeader ? <Footer /> : null} */}
                    {/* { (_showHeader && !user ) ? <Footer /> : null} */}
                </div>
            </div>
        </>
    );
}
export default LayoutUser;
